/* eslint-disable react/jsx-no-undef */
import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage, injectIntl } from 'react-intl';
import moment from 'moment';
import classNames from 'classnames';
import messages from './simulatedMessages';
import './SimulatedCard.scss';

function SimulatedCard(props) {
  const { formatMessage } = props.intl;
  const applicationMethodArr = [
    {
      name: formatMessage(messages.printed),
    },
    {
      name: '',
    },
    {
      name: formatMessage(messages.online),
    },
    {
      name: formatMessage(messages.printedPlusWriting),
    },
    {
      name: formatMessage(messages.onlinePlusWriting),
    },
  ];
  // console.log(props);
  return (
    <div className="card card-school simulated-card" style={props.style}>
      <div className="card-body" onClick={props.onClick} style={{ cursor: 'pointer' }}>
        <div className="card-id">ID: {props.idString}</div>
        <div className="fixed-actions">
          <button className="edit-card" onClick={props.onClick}>
            <i className="ti-pencil-alt" />
            {formatMessage(messages.edit)}
          </button>
        </div>
        {/* <i className={classNames('pt-3 cm-icon', props.iconClassName)} /> */}
        <h5 className="card-title my-0 mt-0" style={{ color: '#F59F8D' }}>
          {props.levelSegment.map((l) => (
            <div className="level-segment">{l}</div>
          ))}
          <div className="application-lbl"><FormattedMessage {...messages.application} /></div>
          <div>{props.application}</div>
        </h5>
        <div className="card-content">
          <div className="identification-lbl"><FormattedMessage {...messages.evaluationLevelNotebook} /></div>
          <p className="mb-0 mt-0 identification-txt">{props.identification || ''}</p>
          <p className="mb-0 mt-3">{props.period || ''}</p>
          <p>{props.abbreviation || ''}</p>
          {props.date && (
            <p>
              {formatMessage(messages.deliver)}: {moment(props.date).format('DD/MM/YYYY')}
            </p>
          )}
          <div>
            <p className="mb-0">
              {props.students_number}{' '}
              {Number(props.students_number) === 1 ? (
                <FormattedMessage {...messages.studentsSingle} />
              ) : (
                <FormattedMessage {...messages.studentsPlural} />
              )}
            </p>
            <p className="mb-4">
              {props.answered}{' '}
              {Number(props.answered) === 1 ? (
                props.applicationMethod === '2' ? (
                  <FormattedMessage {...messages.testAnsweredSingle} />
                ) : (
                  <FormattedMessage {...messages.replyCardsAttachedSingle} />
                )
              ) : props.applicationMethod === '2' ? (
                <FormattedMessage {...messages.testAnsweredPlural} />
              ) : (
                <FormattedMessage {...messages.replyCardsAttachedPlural} />
              )}
            </p>
          </div>
        </div>
        {/* <div className="mt-5 mb-3">
          {props.dateStatus.status === '0' ? (
            <span className="btn btn-sm btn-grey" style={{ marginBottom: '10px' }}>
              {formatMessage(messages.questionNoDate)}
            </span>
          ) : props.dateStatus.complete ? (
            <button className="btn btn-sm btn-success" onClick={props.onClick}>
              {formatMessage(messages.completed)}
            </button>
          ) : (
            <button className="btn btn-sm btn-danger" onClick={props.onClick}>
              {props.dateStatus.name} {formatMessage(messages.to)} {props.dateStatus.date}
            </button>
          )}
        </div> */}
        <div className="application-method">
          {applicationMethodArr[props.applicationMethod].name}
        </div>
      </div>
    </div>
  );
}

SimulatedCard.propTypes = {
  id: PropTypes.string,
  coordinator: PropTypes.bool.isRequired,
  onClick: PropTypes.func,
  iconClassName: PropTypes.string,
  title: PropTypes.string,
  period: PropTypes.string,
  date: PropTypes.oneOf(PropTypes.string, PropTypes.date),
  amountStudents: PropTypes.number,
  amountCards: PropTypes.number,
  badge: PropTypes.node,
  intl: PropTypes.object,
};

SimulatedCard.defaultProps = {
  iconClassName: 'pe-7s-light',
  dateStatus: {},
};

export default injectIntl(SimulatedCard);
